<template>
    <div
        class="modal fade right"
        id="marking_modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="ページをメモリーする"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered modal-fullscreen-md-down" role="document">
            <div class="modal-content" v-if="node">
                <div class="modal-header text-center">
                    {{ node.name }}
                    <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                    <div class="position-relative">
                        <img :src="node.node_image" :alt="node.name" class="img-fluid mb-2" />
                        <p>このページをマイメモリーに追加しますか？</p>
                    </div>
                    <a href="https://www.youtube.com/watch?v=vA218vwwZyY" target="_blank">
                        <img src="/img/memory/clickme-memory.png" class="img-fluid my-2" alt="記録用QRコードであなたのライフスタイルがスマートに変わります">
                    </a>
                </div>
                <div class="modal-footer">
                    <div class="d-flex justify-content-between">
                        <button class="btn btn-primary me-2" @click.prevent="mark()" :disabled="marking">はい</button>
                        <button class="btn btn-default" data-mdb-dismiss="modal">いいえ</button>
                    </div>
                    <notify-agreement v-if="login_status == 0"></notify-agreement>
                    <form id="marking_form">
                        <input type="hidden" name="node_id" class="node_id" :value="node.id" />
                        <input type="hidden" name="ccode" :value="ccode" />
                        <input type="hidden" name="sub_code" :value="sub_code" />
                        <input type="hidden" name="from_screen" :value="from_screen" />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotifyAgreement from '@v/NotifyAgreement';

import request from '@js/modules/utils/request';
import utils from '@js/modules/utils/utils';

export default {
    name: 'MarkingModal',
    props: ['node', 'ccode', 'sub_code', 'from_screen', 'login_status'],
    data: function () {
        return {
            modal: null,
            marking: false,
        };
    },
    methods: {
        mark() {
            utils.loading(true, 0);
            this.marking = true;
            request.postAs('/save-memory', 'marking_form')
                .then(res => {
                    const response = res.data;
                    window.location.href = response.url;
                })
                .catch(res => {
                    request.showErrorResponse(res, 'marking_form');
                })
                .finally(() => {
                    this.marking = false;
                    utils.loading(false);
                });
        },
    },
    components: {
        NotifyAgreement,
    },
};
</script>

<style scoped>
.marking_img {
    position: fixed;
    left: auto;
    top: 5em;
    right: 5vw;
    bottom: auto;
    z-index: 1000;
    height: auto;
    width: 15vw;
    max-width: 100px;
}
</style>
